// Sentry initialization must be imported first!
import './instrument'
import * as Sentry from '@sentry/react'
import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { Auth0Provider } from '@auth0/auth0-react'
import { auth0Config } from './lib/auth'
import { InnerApp } from './app'
import { AppErrorBoundary } from './components/app-error-boundary'
import './styles/index.css'

createRoot(document.getElementById('root')!, {
  // Route React's internal error callbacks to Sentry.
  onUncaughtError: Sentry.reactErrorHandler(),
  onCaughtError: Sentry.reactErrorHandler(),
  onRecoverableError: Sentry.reactErrorHandler(),
}).render(
  <StrictMode>
    <AppErrorBoundary>
      <Auth0Provider
        domain={auth0Config.domain}
        clientId={auth0Config.clientId}
        cacheLocation={auth0Config.cacheLocation}
        useRefreshTokens={auth0Config.useRefreshTokens}
        authorizationParams={auth0Config.authorizationParams}
      >
        <InnerApp />
      </Auth0Provider>
    </AppErrorBoundary>
  </StrictMode>,
)
